import { linkToClassesPage } from "../../links";

export function linkToCreateNewClass() {
  return `${linkToClassesPage()}/create-a-class`;
}
